// src/pages/PortalForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import portalApi from '../utils/portalApi';
import toast from 'react-hot-toast';

export default function PortalForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await portalApi.post('/auth/member/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy, #1a3a5c)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '2rem', color: 'white', marginBottom: 6 }}>NJJBA</h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', letterSpacing: '1px', textTransform: 'uppercase' }}>
            Member Portal
          </p>
        </div>
        <div className="card" style={{ padding: '32px 36px' }}>
          <h2 style={{ marginBottom: 8, color: 'var(--navy)', fontFamily: 'var(--font-serif)' }}>Reset Password</h2>
          {submitted ? (
            <>
              <p style={{ marginBottom: 16, color: 'var(--gray-700)', fontSize: '0.9rem' }}>
                If your email is registered, a password reset link has been sent. It expires in 24 hours.
              </p>
              <p style={{ marginBottom: 24, color: 'var(--gray-500)', fontSize: '0.85rem' }}>
                Check your inbox (and spam folder).
              </p>
              <Link to="/portal/login" className="btn btn-primary w-full" style={{ justifyContent: 'center' }}>
                Back to Sign In
              </Link>
            </>
          ) : (
            <>
              <p style={{ marginBottom: 20, color: 'var(--gray-600)', fontSize: '0.875rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@yourbusiness.com"
                    autoFocus
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-full btn-lg" disabled={loading} style={{ marginTop: 8, justifyContent: 'center' }}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem' }}>
                <Link to="/portal/login" style={{ color: 'var(--gray-500)' }}>← Back to Sign In</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
